import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class Loading extends React.Component {
  constructor(props){
      super(props);
      this.state = {
      }
    }


 render() {
   if (this.props.loadingMore)
   return (
      <div style={{textAlign: 'center', margin: 25, color: "orange", width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <CircularProgress
          size={this.props.size ? this.props.size : 40}
          thickness={6}
          color={"inherit"}
        />
      </div>
   )
   else
    return (
      <>
      </>
    )
 }
}


export default Loading;
